import { render, staticRenderFns } from "./MachineDetail.vue?vue&type=template&id=5cf58cd9&scoped=true&"
import script from "./MachineDetail.vue?vue&type=script&lang=js&"
export * from "./MachineDetail.vue?vue&type=script&lang=js&"
import style0 from "./MachineDetail.vue?vue&type=style&index=0&id=5cf58cd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf58cd9",
  null
  
)

export default component.exports